import { Trans } from '@lingui/react/macro';
import { matchPath, useLocation } from 'react-router';

import { Avatar, AvatarImage } from '@/components/Avatar';
import LetteredAvatar from '@/components/LetteredAvatar';
import { InstanceLink } from '@/components/routing';
import {
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  Sidebar as SidebarPrimitive,
  useSidebar,
} from '@/components/Sidebar';
import { Text } from '@/components/typography';
import InstanceSwitcher from '@/features/InstanceSwitcher';
import { useMe } from '@/providers/User';
import { ROUTES } from '@/router';

import { AppMenu } from '../AppMenu';

export type SidebarProps = Record<string, never>;

const Sidebar = () => {
  const { isMobile, setOpenMobile } = useSidebar();
  const user = useMe();
  const { pathname } = useLocation();
  const isProfileActive = matchPath({ path: ROUTES.profile.path, end: false }, pathname) != null;

  const handleMenuSelect = () => {
    if (isMobile) {
      setOpenMobile(false);
    }
  };

  return (
    <SidebarPrimitive data-testid="sidebar">
      <SidebarHeader className="py-5">
        <InstanceSwitcher />
      </SidebarHeader>
      <SidebarContent>
        <AppMenu onMenuSelect={handleMenuSelect} />
      </SidebarContent>
      <SidebarFooter className="p-0">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              isActive={isProfileActive}
              className="h-auto gap-3 px-6 py-3 focus-visible:inset-ring-2 focus-visible:inset-ring-gray-900"
              aria-current={isProfileActive ? 'page' : undefined}
              onClick={handleMenuSelect}
              render={<InstanceLink to={ROUTES.profile.path} />}
            >
              <Avatar size="medium" aria-hidden="true">
                <AvatarImage className="z-10" src={user?.pictureUrl} alt="" />
                <LetteredAvatar
                  className="absolute"
                  name={user?.name}
                  size="large"
                  shape="circle"
                />
              </Avatar>
              <Text variant="body2">
                <Trans>Profile</Trans>
              </Text>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </SidebarPrimitive>
  );
};

export default Sidebar;
